import {useCallback} from "react"
import {useRouter} from "next/router"
import {debounce} from "lodash"

const useRemoveFbclid = () => {
	const router = useRouter()

	const removeFbclid = useCallback(
		debounce(() => {
			const {asPath} = router
			if (asPath.includes("fbclid=")) {
				const urlParts = asPath.split("?")
				const baseUrl = urlParts[0]
				const queryParams = urlParts[1]

				if (queryParams) {
					const params = new URLSearchParams(queryParams)
					params.delete("fbclid")

					// Construct the new URL
					const newUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl

					// Replace the URL without reloading the page
					router.replace(newUrl, undefined, {shallow: true})
				}
			}
		}, 300),
		[router]
	)

	return removeFbclid
}

export default useRemoveFbclid
